import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import {Partenaires} from "./Home/Partenaires";
import {urlBase, urlDirectus} from "../config/Globals";
import maison from "../assets/images/maison.svg";
import ArticleLutte from "../service/ArticleLutteService";
import PilierSevice from "../service/PilierSevice";
import RubriqueService from "../service/RubriqueSevice";

export const PilierLutte = ({wording}) => {

    const { wordingPilier } = useParams();

    const[rubrique, setRubrique] = useState([]);
    const[loadingRubrique, setLoadingRubrique] = useState(1);
    const fetchRubrique = async(wording) => {
        try{
            const data = await RubriqueService.find(wording);
            setRubrique(data);
            setLoadingRubrique(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchRubrique(wording);
    }, [wording]);

    const[pilier, setPilier] = useState([]);
    const[loadingPilier, setLoadingPilier] = useState(1);
    const fetchPilier = async(wordingPilier) => {
        try{
            const data = await PilierSevice.find(wordingPilier);
            setPilier(data);
            setLoadingPilier(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchPilier(wordingPilier);
    }, [wordingPilier]);

    const[piliers, setPiliers] = useState([]);
    const[loadingPiliers, setLoadingPiliers] = useState(1);
    const fetchPiliers = async() => {
        try{
            const data = await PilierSevice.findAll();
            setPiliers(data);
            setLoadingPiliers(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchPiliers();
    }, []);

    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try {
            setLoadingArticles(true);
            const data = await ArticleLutte.findAllInRubrique(id);
            setArticles(data);
        } catch (error) {
            console.error("Erreur lors de la récup des articles", error);
        } finally {
            setLoadingArticles(false);
        }
    }
    useEffect(() => {
        if (pilier && pilier.id) {
            fetchArticles(pilier.id);
        }
    }, [pilier?.id]);


    return (
        <>
            <Helmet>
                <title>{pilier.titre}</title>
                <meta name="description" content={pilier.titre}/>
            </Helmet>
            <main class="type organisation-lutte">
                <section className="bg-gris">
                    <div className="container px-4 position-relative z-1">
                        <div className="row justify-content-center text-center pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb justify-content-center">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                               className="breadcrumb-link">
                                                Tout savoir sur la flavescence dorée
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree/' + rubrique.wording}
                                               className="breadcrumb-link">{rubrique.titre}</a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>
                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            {pilier.titre}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="display-5 fw-sb mb-3">{pilier.titre}</h1>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="bg-white pt-5 pb-xl-5">
                    <div className="container px-4 position-relative z-1">
                        <div className="row g-5 justify-content-center">
                            <div className="col-12 col-lg-9 d-flex flex-wrap justify-content-between">
                                <div className="col-12 col-xl-4 fw-b fs-5 d-flex align-items-end pb-xl-5">
                                    <div className="trait-before">
                                        <p>Quatre piliers de lutte complémentaires et indispensables face à la
                                            Flavescence dorée.</p>
                                    </div>
                                </div>
                                <div className="col-12 col-xl" style={{ maxWidth: '608px' }}>
                                    <div className="col-12 piliers-container piliers-container-type my-5 my-sm-0 position-relative d-flex flex-wrap">
                                        {piliers.map((p) => (
                                            <a
                                                key={p.id}
                                                href={urlBase+'tout-savoir-sur-la-flavescence-doree/'+rubrique.wording+'/'+p.wording}
                                                className={`${p.className} pilier-item d-flex align-items-center gap-3 text-decoration-none ${p.id === pilier?.id ? 'active' : ''}`}
                                            >
                                                {/* Si le texte doit être AVANT l'image */}
                                                {p.textPosition === "before" && (
                                                    <span className={`${p.textClassName} pilier-text fw-sb`} dangerouslySetInnerHTML={{__html: p.text}}></span>
                                                )}

                                                <img
                                                    src={urlDirectus+"assets/"+p.image}
                                                    alt={p.titre}
                                                    className="pilier-icon"
                                                />

                                                {/* Si le texte doit être APRÈS l'image */}
                                                {p.textPosition === "after" && (
                                                    <span className={`${p.textClassName} pilier-text fw-sb`} dangerouslySetInnerHTML={{__html: p.text}}></span>
                                                )}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {articles.map((article,index) => {
                    if (index === 0) {
                        return (
                            <section key={article.id} className={`content-piliers py-5`}>
                                <div className="container-fluid position-relative z-1">
                                    <div className="row">
                                        <div className={`col-12 col-lg-6 px-0 d-flex flex-column justify-content-center ${article.bgClass}`}>
                                            <div className="p-5">
                                                <h2>{article.titre}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: article.contenu }} />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 px-0">
                                            <img
                                                src={urlDirectus+"assets/"+article.image}
                                                alt={article.titre}
                                                className="img-fluid w-100 h-100 object-fit-cover"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        );
                    }
                    const isEven = index % 2 === 0;
                    return (
                        <section key={article.id} className={`content-piliers content-piliers-type ${isEven ? 'bg-gris py-5' : 'bg-white py-5'}`}>
                            <div className="container-fluid position-relative z-1">
                                <div className={`row align-items-center ${isEven ? 'flex-row-reverse' : ''}`}>
                                    <div
                                        className="col-lg-6 px-4 px-lg-0 d-flex align-items-center justify-content-center">
                                        <img src={urlDirectus + "assets/" + article.image} alt={article.titre}
                                             className="img-fluid"/>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="p-4 p-lg-5">
                                            <h2>{article.titre}</h2>
                                            <div dangerouslySetInnerHTML={{__html: article.contenu}}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    );
                })}

                <section className="content-piliers content-piliers-type bg-white py-5">
                    <div className="container-fluid position-relative z-1">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-12 text-center">
                                <a href={urlBase+"faq"} className="d-inline-flex btn btn-warning mx-auto mt-4">Pour en savoir plus, consulter la rubrique FAQ</a>
                            </div>
                        </div>
                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    )
}